export default __webpack_public_path__ + "static/media/pindown1.292e1199.png";